import { all, fork, takeLatest, put, call, race, delay } from 'redux-saga/effects';

import { GENERATE_LIVEKIT_TOKEN } from '../actions/types';

import { func } from 'config/firebase';

import { httpsCallable } from 'firebase/functions';
import {
    generateLiveKitTokenFailure,
    generateLiveKitTokenSuccess
} from 'store/actions/LiveKit';
import { log } from 'utils/Loggers';

const generateLiveKitAccessToken = httpsCallable(func, 'generateLiveKitAccessToken');

// A token is signed in milliseconds, so anything past this is a stalled request. Without
// a bound the operator sits on a fielded call with no video and no way to end it.
const TOKEN_TIMEOUT_MS = 15000;

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////// Generate LiveKit Token ///////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getLiveKitTokenRequest = async payload => {
    try {
        const { roomName, participantName } = payload;

        const request = await generateLiveKitAccessToken({ roomName, participantName });
        return { token: request.data.token };
    } catch (error) {
        return { error };
    }
};

function* getLiveKitToken({ payload }) {
    // A throw here would bubble up through the root saga's all() and cancel every
    // saga in the app, the calls listener included, freezing the Virtual Guard page.
    const { result, timeout } = yield race({
        result: call(getLiveKitTokenRequest, payload),
        timeout: delay(TOKEN_TIMEOUT_MS)
    });

    if (result?.token) {
        yield put(generateLiveKitTokenSuccess(result.token));
    } else {
        const error = timeout
            ? 'Timed out connecting to the call.'
            : result?.error?.message || 'Unable to connect to the call.';
        log('LiveKit Token: error generating access token', { error, payload });
        yield put(generateLiveKitTokenFailure(error));
    }
}

///////////// Action Creators For Root Saga //////////////////

export function* generateLiveKitToken() {
    yield takeLatest(GENERATE_LIVEKIT_TOKEN, getLiveKitToken);
}

export default function* rootSaga() {
    yield all([fork(generateLiveKitToken)]);
}
